import React, { useState, useEffect } from 'react'
import { useAuth0 } from '@auth0/auth0-react'
import { useNavigate } from 'react-router-dom'
import * as Sentry from '@sentry/react'

const { logger } = Sentry;
import './StickyCTA.scss'

function StickyCTA() {
  const { loginWithPopup, isAuthenticated } = useAuth0()
  const [isLoading, setIsLoading] = useState(false)
  const [isVisible, setIsVisible] = useState(false)
  const navigate = useNavigate()

  useEffect(() => {
    if (isAuthenticated) {
      setIsVisible(false)
      return
    }

    const handleScroll = () => {
      // Show after scrolling 300px
      const scrollPosition = window.scrollY || document.documentElement.scrollTop
      setIsVisible(scrollPosition > 300)
    }

    window.addEventListener('scroll', handleScroll)
    return () => window.removeEventListener('scroll', handleScroll)
  }, [isAuthenticated])

  const handleGetStarted = async () => {
    setIsLoading(true)
    try {
      const width = 700
      const height = 900
      const left = window.screen.width / 2 - width / 2
      const top = window.screen.height / 2 - height / 2
      
      const popup = window.open(
        '',
        'auth0:authorize:popup',
        `width=${width},height=${height},left=${left},top=${top},resizable,scrollbars=yes,status=1`
      )
      
      await loginWithPopup({
        authorizationParams: {
          screen_hint: 'signup'
        }
      }, { popup } as any)
    } catch (error) {
      logger.error('Login error', {
        error: error instanceof Error ? error.message : String(error),
      });
    } finally {
      setIsLoading(false)
    }
  }

  if (!isVisible || isAuthenticated) {
    return null
  }

  return (
    <div className="sticky-cta">
      <div className="sticky-cta-content">
        <div className="sticky-cta-text">
          <strong>Ready to land your next interview?</strong>
          <span>Start free, no credit card needed</span>
        </div>
        <button
          type="button"
          className="btn btn-primary btn-lg fw-bold"
          onClick={handleGetStarted}
          disabled={isLoading}
        >
          {isLoading ? 'Loading...' : 'Get Started Free'}
        </button>
      </div>
    </div>
  )
}

export default StickyCTA

